import { createContext, useContext, type ReactNode } from "react";
import { useAuth } from "../auth/AuthProvider";

export type EntityLabels = {
  customer: string;
  customers: string;
  customerNew: string;
  project: string;
  projects: string;
};

export const DEFAULT_ENTITY_LABELS: EntityLabels = {
  customer: "לקוח",
  customers: "לקוחות",
  customerNew: "לקוח חדש",
  project: "פרויקט",
  projects: "פרויקטים",
};

const EntityLabelsContext = createContext<EntityLabels>(DEFAULT_ENTITY_LABELS);

export function EntityLabelsProvider({ children }: { children: ReactNode }) {
  const auth = useAuth();
  const labels = auth.activeTenant?.labels ?? DEFAULT_ENTITY_LABELS;
  return (
    <EntityLabelsContext.Provider value={labels}>{children}</EntityLabelsContext.Provider>
  );
}

export function useEntityLabels(): EntityLabels {
  return useContext(EntityLabelsContext);
}
